export const getChargeText = (price: number) => {
	if (price !== 0) {
		const prefix = price > 0 ? '+' : '-'
		return `（${prefix}\xA5${Math.abs(price).toLocaleString()}）`
	}
	return ''
}
